import React from 'react';
import { Gift, Clock, MapPin, List } from 'lucide-react';
export function BonusStack() {
  const bonuses = [{
    icon: <List className="h-8 w-8 text-brand-gold" data-id="element-1" />,
    title: 'Lista de Emergencia Anti-Inflamación',
    desc: 'Los 10 alimentos que puedes comer ILIMITADAMENTE durante el reset. Tu salvavidas cuando el hambre aparece.',
    value: '$27',
    id: 1
  }, {
    icon: <Clock className="h-8 w-8 text-brand-gold" data-id="element-2" />,
    title: 'El Protocolo de Mañana de 10 Minutos',
    desc: 'La rutina exacta que activa tu metabolismo antes del desayuno. Sin ejercicio intenso. Solo 3 pasos simples.',
    value: '$27',
    id: 2
  }, {
    icon: <MapPin className="h-8 w-8 text-brand-gold" data-id="element-3" />,
    title: 'Guía de Restaurantes USA',
    desc: "Cómo comer fuera de casa sin sabotear tu reset. Qué pedir en McDonald's, Starbucks, Chipotle y más.",
    value: '$27',
    id: 3
  }];
  return <section className="py-16 bg-brand-dark text-white relative overflow-hidden" data-id="element-4">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-brand-gold/5 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-5"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-6">
        <div className="text-center mb-12" data-id="element-7">
          <span className="inline-block bg-brand-gold text-brand-dark font-bold px-4 py-1 rounded-full text-sm mb-4" data-id="element-8">
            SOLO POR HOY
          </span>
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-brand-gold mb-4" data-id="element-9">
            ADEMÁS, HOY RECIBES ESTOS BONOS GRATIS:
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-10">
          {bonuses.map(bonus => <div key={bonus.id} className="bg-brand-dark/50 border border-brand-gold/30 rounded-xl p-6 hover:border-brand-gold transition-colors relative group" data-id="element-11">
              <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-brand-gold text-brand-dark text-xs font-bold px-3 py-1 rounded shadow-lg" data-id="element-12">
                BONO #{bonus.id} — VALOR: {bonus.value}
              </div>
              <div className="mt-4 mb-4 bg-brand-gold/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto group-hover:bg-brand-gold/20 transition-colors" data-id="element-13">
                {bonus.icon}
              </div>
              <h3 className="text-xl font-serif font-bold text-center mb-3 text-brand-cream" data-id="element-14">
                {bonus.title}
              </h3>
              <p className="text-gray-300 text-center text-sm leading-relaxed" data-id="element-15">
                {bonus.desc}
              </p>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-16">
          <p className="text-xl font-serif text-brand-gold italic" data-id="element-17">
            Valor Total de los Bonos: $81 USD{' '}
            <span className="text-white not-italic font-bold ml-2" data-id="element-18">
              (GRATIS HOY)
            </span>
          </p>
        </div>
      </div>
    </section>;
}